var webooker_courses_models = webooker_courses_models || {};

(function (ns) {

    // #region CourseRegistrationAttendance - ctor

    ns.CourseRegistrationUserSchedule = function CourseRegistrationUserSchedule(courseScheduleDTO) {

        this.origCapacity = courseScheduleDTO.capacity;
        this.origFilled = courseScheduleDTO.filled;

        this.startDate = courseScheduleDTO.startDate;
        this.endDate = courseScheduleDTO.endDate;
        this.courseScheduleID = courseScheduleDTO.courseScheduleID;

        this.$courseRegistrationAttendance = [];

    };

    // #endregion

    Object.defineProperty(ns.CourseRegistrationUserSchedule.prototype, 'freePlaces', {
        enumerable: true, configurable: true,
        get: function () {
            var origFreeCapacity = Math.max(0, this.origCapacity - this.origFilled);

            var placesRequiredByRegistration = _.reduce(this.$courseRegistrationAttendance, function (sum, a) {
                if (a.hasChanged) {
                    return sum + (a.isRegistered ? 1 : 0);
                }

                return sum;
            }, 0);

            return Math.max(0, origFreeCapacity - placesRequiredByRegistration);
        }
    });

    ns.CourseRegistrationUserSchedule.prototype.addCourseRegistrationAttendance =
        function (courseRegistrationAttendance /* Array */) {
            this.$courseRegistrationAttendance = courseRegistrationAttendance;

            angular.forEach(this.$courseRegistrationAttendance, function (cra) {
                cra.setUserScheduleBinding.call(cra, this);
            }, this);
    }

})(webooker_courses_models);